const footer = document.querySelector("footer")

const footerMenus = footer.querySelectorAll("details")

footerMenus.forEach((menu)=>{
    const currentMenuHeading = menu.querySelector(".menu__heading__default")
    if(currentMenuHeading.innerHTML === "Socials"){
    const lis = menu.querySelectorAll(".menu__item a")
            if(lis){
                lis.forEach((li)=>{
                li.setAttribute("target" , "_blank")
            })
            }
    }
})



